import { Box, Grid, Typography } from '@material-ui/core'
import BrandsFragment from 'bl-health/components/ReplacementPartsCatalogStrategy/BrandsFragment'
import PartsFragment from 'bl-health/components/ReplacementPartsCatalogStrategy/PartsFragment'
import ProductsFragment from 'bl-health/components/ReplacementPartsCatalogStrategy/ProductsFragment'
import ActionFragment from 'bl-health/components/ReplacementPartsCatalogStrategy/ActionFragment'
import useReplacementPartsCatalogStrategy from './utils/useReplacementPartsCatalogStrategy'
import css from './ReplacementPartsCatalogStrategy.styles.scss'
import ReplacementPartsCatalogStrategySkeleton from './ReplacementPartsCatalogStrategySkeleton'
import ReplacementPartsCatalogStrategyError from './ReplacementPartsCatalogStrategyError'

export default function ReplacementPartsCatalogStrategy() {
  const {
    brandsController,
    productsController,
    partsController,
    showErrorBlock,
  } = useReplacementPartsCatalogStrategy()

  if (brandsController.isLoading) {
    return <ReplacementPartsCatalogStrategySkeleton />
  }

  if (showErrorBlock) {
    return <ReplacementPartsCatalogStrategyError />
  }

  return (
    <div className={css.ReplacementPartsCatalogStrategy}>
      <Box m="auto" maxWidth={400}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={css.ReplacementPartsCatalogStrategy__hero}>
              <p className={css.ReplacementPartsCatalogStrategy__hero__title}>
                You're eligible for free replacement parts!
              </p>
              <Typography variant="body2">
                Choose from a wide variety of pump models for which we offer
                replacement parts. We'll even cover shipping!
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12}>
            <Typography gutterBottom variant="body2">
              Select an available pump brand and model.
            </Typography>
          </Grid>

          <BrandsFragment controller={brandsController} />

          <ProductsFragment
            controller={productsController}
            key={brandsController.selected?.brand}
          />

          <PartsFragment
            controller={partsController}
            key={productsController.selected?.id}
          />

          <ActionFragment
            brandsController={brandsController}
            key={`${productsController.selected?.id}-${partsController.selected?.id}`}
            partsController={partsController}
            productsController={productsController}
          />
        </Grid>
      </Box>
    </div>
  )
}
